import { Component, h, Prop, State, Host, Listen, Element } from '@stencil/core';

@Component({
  tag: 'kdx-speedbump',
  styleUrl: 'kdx-speedbump.scss',
  shadow: false,
})
export class AppSpeedbump {

  @Element() root: HTMLElement;

  primaryLink!: HTMLAnchorElement;

  @Prop() warningHeading: string;
  @Prop() titleHeading: string;
  @Prop() returnText: string;
  @Prop() continueText: string;
  @Prop() defaultMessage: string;

  @State() info = {
    open: false,
    message: '',
    url: ''
  };

  @Listen('click', { target: 'document' })
  openSpeedbump(e: PointerEvent) {
    const speedbumpLink = (e.target as Element).closest('a.speedbump-link') as HTMLAnchorElement;
    if (!speedbumpLink)
      return;

    e.preventDefault();

    this.info = {
      open: true,
      message: this.defaultMessage,
      url: speedbumpLink.href
    };
    window.addEventListener('keydown', this.focusTrap);
  }

  componentDidRender() {
    if (this.info.open) {
      this.primaryLink.focus();
    }
  }

  closeSpeedbump(e, allowDefault = false) {
    if (!allowDefault) {
      e.preventDefault();
    }

    this.info = {
      open: false,
      message: '',
      url: ''
    };
    window.removeEventListener('keydown', this.focusTrap);
  }

  focusTrap(e) {
      if (e.keyCode === 9) {
          let focusable = document.querySelector('.speedbump__actions').querySelectorAll('input,button,select,textarea,a');
          if (focusable.length) {
              let first = focusable[0];
              let last = focusable[focusable.length - 1];
              let shift = e.shiftKey;
              if (shift && e.target === first) {
                  (last as HTMLElement).focus();
                  e.preventDefault();
              }
              else if (e.target === last) {
                  (first as HTMLElement).focus();
                  e.preventDefault();
              }
          }
      }
  }


  render() {
    if (!this.info.open) {
      return (<Host />);
    }

    return (
      <div class="speedbump" role="alert" aria-label={this.info.message}>
        <div class="speedbump__overlay" onClick={(e) => {this.closeSpeedbump(e)}}></div>
        <div class="speedbump__inner">
            <div class="speedbump__content">
              
              <span class="warning-heading">{this.warningHeading}</span>
              <h1 class="title-heading">{this.titleHeading}</h1>
              <p class="speedbump__message" innerHTML={this.info.message}></p>
            </div>
            

              <div class="speedbump__actions">
                  <a
                    ref={e => this.primaryLink = e}
                    href="#"
                    aria-label={this.returnText}
                    onClick={(e) => {this.closeSpeedbump(e)}}
                    class="btn btn-primary">
                    {this.returnText}
                    
                  </a>
                  <a
                    href={this.info.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={this.continueText}
                    class="btn btn-secondary"
                    onClick={(e) => {this.closeSpeedbump(e, true)}}>
                    {this.continueText}
                    <kdx-icon icon='chevron-right'></kdx-icon>
                  </a>
              </div>
            </div>
      </div>
    );
  }

}
